export default {
  'pages.notFound': 'Η σελίδα δεν υπάρχει',

  'pages.categories.noResults': 'Προσωρινά δεν έχουμε περιεχόμενο',
  'pages.categories.notFound': 'Δεν βρέθηκε το προϊόν',

  'pages.products.noResults': 'Δεν βρέθηκαν προϊόντα',
  'pages.products.noResults.details': 'Δες όλα τα προϊόντα της',
  'pages.products.noResults.details.link': 'κατηγορίας {title}',
  'pages.products.notFound': 'Δεν βρέθηκε η κατηγορία',
  'pages.products.quantity': '{productsCount} προϊόντα',

  'pages.product.related': 'Περισσότερα προϊόντα',

  'footer.madeWithLove': 'Made with love',
  'footer.whatIsThis': 'What is this',

  'notFound.title': 'Δες όλες τις',
  'notFound.link': 'κατηγορίες προϊόντων',

  'breadcrumb.landing': 'Αρχική',

  'activeFilter.price.both': '{minValue}  έως {maxValue}',
  'activeFilter.price.min': 'από {minValue}',
  'activeFilter.price.max': 'εώς {maxValue}',

  'filters.label': 'φίλτρα',
  'filters.overlay.submit': 'Προιόντα',
  'filters.overlay.cancel': 'Ακύρωση',
  'filters.price.label': 'Τιμή',

  'sorting.desc.label': 'Φθηνότερα',
  'sorting.desc.title': 'Φθινότερα πρώτα',
  'sorting.asc.label': 'Ακριβότερα',
  'sorting.asc.title': 'Ακριβότερα πρώτα',

  'pagination.prev': 'Προηγούμενο',
  'pagination.next': 'Επόμενο',
  'pagination.goto': 'Σελίδα {page}',

  'app.close': 'Κλείσιμο',

  'error.connection': 'Η σύνδεση δεν είναι καλή',
  'error.general': 'Ουπς, συνέβει κάποιο σφάλμα'
};
